import Boolean from './Boolean';
import Color from './Color';
import CreditCard from './CreditCard';
import Currency from './Currency';
import DateFormat from './DateFormat';
import Email from './Email';
import File from './File';
import Integer from './Integer';
import Json from './Json';
import Numerical from './Numerical';
import Percent from './Percent';
import Phone from './Phone';
import Text from './Text';
import ZipCode from './ZipCode';

export default {
  Boolean,
  Color,
  Currency,
  CreditCard,
  DateFormat,
  Email,
  File,
  Integer,
  Json,
  Numerical,
  Percent,
  Phone,
  Text,
  ZipCode,
};
